<template lang="pug">
.v-image-slider.image-slider(:class="['image-slider--' + mode, {'loading': loading, 'image-slider--full': slider && slider.items && slider.items.length > 1}]")
	v-loader.image-slider__loader(:loading="!isLoadImages")
	.image-slider__slider(v-if="slider && slider.items && slider.items.length")
		.image-slider__main
			button.image-slider__arrow.image-slider__arrow--prev(type="button" ref="item-prev" aria-label="Предыдущий слайд")
				v-svg-icon.image-slider__arrow-icon(icon="slide-left")
				v-svg-icon.image-slider__arrow-bg(icon="slide-left-bg")
			button.image-slider__arrow.image-slider__arrow--next(type="button" ref="item-next" aria-label="Следующий слайд")
				v-svg-icon.image-slider__arrow-icon(icon="slide-right")
				v-svg-icon.image-slider__arrow-bg(icon="slide-right-bg")
			template(v-if="!isSm")
				.image-slider__btns-wrapper(v-if="slider.buttons && slider.buttons.length")
					template(v-for="(item, itemIndex) in slider.buttons" :key="itemIndex")
						button.btn.image-slider__btn(v-if="item.text"
								type="button"
								:aria-label="item.text"
								:class="[item.className || '', { 'btn--active-disabled': itemIndex === activeButtonIndex }]"
								@click="imagesTypeChanged(item.type, itemIndex)")
							| {{item.text}}
			v-swiper-slider.image-slider__main-slider(v-if="slider && slider.items && slider.items.length"
					:options="options"
					:navigation="navigation"
					:thumbs="computedThumbs"
					@slide-change="onSlideChange"
					@swiper="onSwiper")
				template(v-if="selectedImages"
						v-for="(slide, index) in selectedImages"
						:key="index")
					v-swiper-slide.image-slider__main-slide(:virtualIndex="index")
						.image-slider__item
							button.hero-slider__gallery-btn(type="button"
									@click="openGallery(index)"
									v-if="mode === 'regular'"
									aria-label="Открыть во весь экран")
							template(v-if="slide.type === 'video'")
								.image-slider__iframe-wrap
									template(v-if="isSm")
										.image-slider__item-video-link(@click="playVideo(slide)")
										img.image-slider__img-background(:src="slide.video.poster" alt="" loading="lazy")
										img.image-slider__image(:src="slide.video.poster" alt="" loading="lazy")
										v-svg-icon.image-slider__card-icon(icon="reviews-big-play")
									template(v-else)
										v-video.image-slider__iframe(v-if="realIndex === index"
												:src="slide.video.src"
												:type="slide.video.type"
												:autoplay="videoOptions.autoplay"
												:controls="videoOptions.controls"
												:muted="videoOptions.muted"
												:modalClass="videoOptions.modalClass"
												:modalProp="videoOptions.modalProp"
												:index="index")
							template(v-else)
								img.image-slider__img-background(:src="slide.small"
										v-if="(isiOS && mode === 'gallery' ? !isSm : true)"
										:class="{'image-slider__img--loading': !isLoadImages }"
										:loading="index <= (isSm ? 1 : 0) ? 'eager' : 'auto'")
								v-image.image-slider__image(v-if="(mode === 'gallery') || isLoaded"
										:src="slide.big"
										:class="{'image-slider__img--loading': !isLoadImages }"
										:sources="isSm ? null : computedSourcesBig(slide)"
										:fetchpriority="index <= (isSm ? 1 : 0) ? 'high' : 'low'"
										:loading="index <= (isSm ? 1 : 0) ? 'eager' : 'auto'")
			template(v-if="isSm")
				.image-slider__btns-wrapper(v-if="slider.buttons && slider.buttons.length")
					template(v-for="(item, itemIndex) in slider.buttons" :key="itemIndex")
						button.image-slider__btn(v-if="item.text"
								type="button"
								:aria-label="item.text"
								:class="[item.className || '', { 'btn--active-disabled': itemIndex === activeButtonIndex }]"
								@click="imagesTypeChanged(item.type, itemIndex)")
							| {{item.text}}
		.image-slider__colors-picker(v-if="activeFilter")
			v-field(v-model="activeFilter.value" :field="{...activeFilter}" @update:model-value="filterChanged(activeFilter)")
		.image-slider__thumbs
			v-swiper-slider(:options="thumbOptions"
					:navigation="navigation"
					@swiper="setThumbsSwiper")
				template(v-if="selectedImages"
						v-for="(slide, index) in selectedImages"
						:key="index")
					v-swiper-slide.image-slider__thumbs-slide
						img.image-slider__thumbs-img(:key="uniqueId"
								:src="(slide.type === 'video') ? slide.video.poster : slide.small"
								:class="{'image-slider__img--loading': !isLoadImages, 'image-slider__thumbs-img--active': realIndex === index}"
								@load="checkImageLoaded"
								@error="handleImageError"
								alt=""
								:loading="index < firstImagesLoadCount ? 'eager' : 'lazy'")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId';
import {SwiperSlide} from 'swiper/vue';
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import loadMixin from './mixins/v-load-mixin.vue';
import breakpoints from '../scripts/breakpoints.js';
import isGetPreviewMixin from '../components/mixins/v-mixin-get-preview.vue';

export default {
	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin,
		isGetPreviewMixin,
		loadMixin
	],

	props: {
		mode: {
			type: String,
			default: 'regular'
		},

		title: {
			type: String,
			default: null
		},

		initialIndex: {
			type: Number,
			default: 0
		},

		slidesCount: {
			type: Number,
			default: null
		}
	},

	data() {
		return {
			slider: {},
			btns: null,
			remote: null,
			imageItems: [],
			uniqueId: uniqueId('swiper-'),
			activeButtonIndex: null,
			activeType: null,
			isLoadImages: false,
			imagesLoaded: 0,
			totalImages: 0,
			firstImagesLoadCount: 10,
			selectedImages: null,
			wasIt: {},
			computedAnswerArray: [],
			postersLoaded: false,
			videoOptions: {
				"autoplay": true,
				"muted": true,
				"controls": false,
				'modalClass': 'modal--mini',
				'modalProp': {
					"autoplay": true,
					"muted": false,
					"modalClass": false,
					"controls": true,
				}
			},
			swiperInstance: null,
			realIndex: this.initialIndex,
			options: {
				spaceBetween: 2,
				virtual: {
					slides: this.selectedImages,
					enabled: true,
					addSlidesAfter: 1,
				},
				initialSlide: this.initialIndex,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 1,
						loop: (this.mode !== 'gallery'),
					},
					[breakpoints['sm-mid']]: {
						slidesPerView: (this.mode === 'gallery') ? 1 : 3,
						followFinger: false,
					},
					[breakpoints['2xs-mid']]: {
						slidesPerView: (this.mode === 'gallery') ? 1 : 2,
						followFinger: false,
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: this.slidesCount || 1,
						followFinger: false,
					}
				}
			},
			thumbOptions: {
				spaceBetween: 3,
				slidesPerView: 'auto',
				loop: true
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false,
			thumbsSwiper: null
		};
	},

	created() {
		if (this.initialIndex) {
			this.realIndex = this.initialIndex;
			this.options.initialSlide = this.initialIndex;
		}
		this.firstImagesLoadCount = this.isSm ? 2 : (this.is2Mid && !this.isMid) ? 10 : 7;
	},

	unmounted() {
		this.selectedImages = null;
		this.slider = null;
	},

	watch: {
		selectedImages: {
			handler() {
				this.resetIndex();
			},
			deep: true
		}
	},

	computed: {
		activeFilter() {
			if (!this.slider || !this.slider.buttons || this.slider.buttons.length === 0) {
				return null;
			}
			const activeButton = this.slider.buttons[this.activeButtonIndex];
			return activeButton && activeButton.filter ? activeButton.filter : null;
		},

		computedThumbs() {
			return {
				swiper: this.thumbsSwiper
			};
		},

		//To load images as you progress through the slides
		computedSelectedImages() {
			if (!Array.isArray(this.selectedImages)) {
				return [];
			}
			const numberOfBatches = Math.floor(this.selectedImages.length / 10);
			for (let i = 0; i <= numberOfBatches; i++) {
				const startIndex = i * 10;
				const endIndex = startIndex + 10;
				if (this.isSm) {
					if (!this.wasIt['00']) {
						this.computedAnswerArray = this.selectedImages.slice(startIndex, 3);
						this.wasIt['00'] = true;
					}
					if (this.realIndex >= startIndex + 1 && this.realIndex <= startIndex + 2 && !this.wasIt['01']) {
						this.computedAnswerArray = this.computedAnswerArray.concat(this.selectedImages.slice(3, 10));
						this.wasIt['01'] = true;
					}
					if (!this.wasIt[`${i + 1}`] && this.realIndex >= startIndex + 3 && this.realIndex <= startIndex + 9) {
						this.computedAnswerArray = this.computedAnswerArray.concat(this.selectedImages.slice(startIndex + 10, endIndex + 10));
						this.wasIt[`${i + 1}`] = true;
					}
				} else {
					if (!this.wasIt['0']) {
						this.computedAnswerArray = this.selectedImages.slice(startIndex, endIndex);
						this.wasIt['0'] = true;
					}
					if (!this.wasIt[`${i + 1}`] && this.realIndex >= startIndex + 2 && this.realIndex <= startIndex + 9) {
						this.computedAnswerArray = this.computedAnswerArray.concat(this.selectedImages.slice(startIndex + 10, endIndex + 10));
						this.wasIt[`${i + 1}`] = true;
					}
				}
			}
			return this.computedAnswerArray;
		},

		country() {
			return this.$store.getters['delivery/country'];
		},
	},

	methods: {
		changeLoad() {
			this.isLoaded = true;
		},

		onSwiper(swiper) {
			this.navigation = {
				prevEl: this.$refs['item-prev'],
				nextEl: this.$refs['item-next']
			};
			this.swiperInstance = swiper;
		},

		onSlideChange(swiper) {
			this.swiperInstance = swiper;
			if (typeof swiper.realIndex !== 'undefined') {
				this.realIndex = swiper.realIndex;
			}
		},

		setThumbsSwiper(swiper) {
			this.thumbsSwiper = swiper;
		},

		playVideo(data) {
			controller.openModal({
				className: 'modal--mini',
				component: {
					name: 'v-video',
					props: {...data.video, poster: null, ...this.videoOptions.modalProp}
				}
			});
		},

		//To update the slider depending on whether it is a modal window or not
		updateGallery() {
			if (this.$el && this.$el.classList && this.$el.classList.contains('image-slider--gallery')) {
				return;
			}
			if (!this.$el.classList.contains('image-slider--gallery')) {
				controller.closeAll();
				this.openGallery();
			}
		},

		openGallery(index) {
			let dataGallery = {
				items: this.slider.items,
				buttons: this.getActiveButtons(),
				remote: this.slider.remote
			};
			controller.openModal({
				className: 'modal--gallery',
				content: `<v-gallery :data-source='${(dataGallery ? JSON.stringify(dataGallery) : null)}' :initial-index='${index}'></v-gallery>`
			});
		},

		checkImageLoaded() {
			this.imagesLoaded++;
			if (this.imagesLoaded >= this.totalImages || this.imagesLoaded >= this.firstImagesLoadCount) {
				this.isLoadImages = true;
			}
		},

		handleImageError() {
			this.imagesLoaded++;
			console.error('Ошибка загрузки изображения');
		},

		getActiveButtons() {
			if (!this.slider || !Array.isArray(this.slider.buttons) || this.slider.buttons.length === 0) {
				return null;
			}
			if (this.activeButtonIndex >= 0 && this.activeButtonIndex < this.slider.buttons.length) {
				return this.slider.buttons.map((button, index) => ({
					...button,
					active: index === this.activeButtonIndex
				}));
			}
			return this.slider.buttons;
		},

		computedSourcesBig(item) {
			return [
				{
					'src': item.orig,
					'size': '2x'
				}
			];
		},

		resetIndex() {
			this.realIndex = 0;
			if (this.thumbsSwiper && this.swiperInstance) {
				this.swiperInstance.slideTo((this.selectedImages?.length > 1) ? 1 : 0);
				this.thumbsSwiper.slideTo((this.selectedImages?.length > 1) ? 1 : 0);
			} else if (this.swiperInstance) {
				this.swiperInstance.slideTo((this.selectedImages?.length > 1) ? 1 : 0);
			} else if (this.thumbsSwiper) {
				this.thumbsSwiper.slideTo((this.selectedImages?.length > 1) ? 1 : 0);
			}
		},

		filterChanged(field) {
			this.isLoadImages = false
			controller.changeColor(field);
		},

		//To upload posters for videos if they are not in data
		async loadPosters() {
			if (this.postersLoaded) return;
			const cacheKey = this.getCacheKey();
			const cachedPosters = sessionStorage.getItem(cacheKey);
			if (cachedPosters) {
				this.slider.items = JSON.parse(cachedPosters);
				this.postersLoaded = true;
				return;
			}
			if (this.slider.items && this.slider.items.length) {
				const hasVideo = this.slider.items.some(item => 'video' in item);
				if (hasVideo) {
					const imageItemsPromises = this.slider.items.map(async (item) => {
						if (!('video' in item)) {
							return item;
						} else if ('video' in item) {
							if (item.video.poster) {
								return item;
							} else {
								try {
									const poster = await this.getPreview(item.video.src);
									return {...item, video: {...item.video, poster}};
								} catch (error) {
									console.error('Ошибка при получении preview:', error);
									return item;
								}
							}
						}
					});
					this.imageItems = await Promise.all(imageItemsPromises);
				} else {
					this.imageItems = this.slider.items;
				}
				this.slider.items = this.imageItems;
				this.postersLoaded = true;
				sessionStorage.setItem(cacheKey, JSON.stringify(this.slider.items));
			}
		},

		getLastPartOfUrl() {
			const path = window.location.pathname;
			const parts = path.split('/').filter(part => part);
			return parts[parts.length - 1] || 'default';
		},

		getCacheKey() {
			const lastPart = this.getLastPartOfUrl();
			return `imageSliderPosters_${lastPart}_${this.country?.value}`;
		},

		initializeImageData() {
			this.uniqueId = uniqueId('swiper-');
			this.isLoadImages = false;
			this.imagesLoaded = 0;
			this.totalImages = 0;
			this.postersLoaded = false;
			if (this.activeType) {
				this.selectedImages = this.slider?.items?.filter(item => item.section === this.activeType) || [];
			} else {
				this.selectedImages = this.slider?.items || [];
			}
			this.totalImages = this.selectedImages.length;
			this.wasIt = {};
		},

		async imagesTypeChanged(imageType, itemIndex) {
			this.activeButtonIndex = itemIndex;
			this.activeType = imageType;
			if (this.activeType && this.activeType === 'video') {
				await this.loadPosters();
			}
			this.initializeImageData();
			await this.$nextTick(() => {
				this.realIndex = 0;
			});
		},

		async dataSet(data) {
			const {buttons = []} = data;
			this.slider = data;
			if (Array.isArray(buttons) && buttons.length > 0) {
				const activeButtonIndex = buttons.findIndex(item => item.active);
				this.activeButtonIndex = activeButtonIndex !== -1 ? activeButtonIndex : null;
				this.activeType = this.activeButtonIndex !== null ? buttons[this.activeButtonIndex].type : null;
			} else {
				this.activeButtonIndex = null;
				this.activeType = null;
			}
			if (this.activeType && this.activeType === 'video') {
				await this.loadPosters();
			}
			this.initializeImageData();
			this.uniqueId = uniqueId('swiper-');
			await this.$nextTick(() => {
				if (document.body.classList.contains('state--modal-open')) {
					this.updateGallery();
				}
			});
		}
	}
};
</script>
